import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { PaymentProviderAcquirerSimulatorComponent } from './components/payment-provider-acquirer-simulator/payment-provider-acquirer-simulator.component';
import { MaterialModule } from '../../material.module';
import { PaymentModule } from '../payment/payment.module';

const routes: Routes = [{
  path: 'simulator',
  children: [
    {
      path: 'acquirer',
      children: [
        {
          path: '',
          component: PaymentProviderAcquirerSimulatorComponent,
          // data: { title: ['Payment Provider PAYMENT'] },
        },
      ],
    }]
}];


@NgModule({
  imports: [
    MaterialModule,
    CommonModule,
    RouterModule.forChild(routes),
    PaymentModule
  ],
  declarations: [
    PaymentProviderAcquirerSimulatorComponent,
  ],
})
export class SimulatorModule { }
